import type { CSSProperties, JSX } from "react";

import { useT } from "../../i18n/index.js";

interface SpinnerProps {
  readonly size?: number;
  readonly label?: string;
}

export const Spinner = ({ size = 18, label }: SpinnerProps): JSX.Element => {
  const t = useT();
  const style: CSSProperties = {
    width: size,
    height: size,
    borderWidth: Math.max(2, Math.round(size / 9)),
  };
  return (
    <span
      className="loom-spinner-wrap"
      role="status"
      aria-live="polite"
      aria-label={label ?? t("dashboard.spinner.loading")}
    >
      <span className="loom-spinner" style={style} aria-hidden="true" />
      {label && <span className="loom-spinner-label">{label}</span>}
    </span>
  );
};
